import 'js/render/index'
import 'styles/3d.scss'
import './lib/loaders'
import ThreeDViewer from './lib/viewer'
import {isDefined} from 'js/render/utils'
import {defaultViewerConfig} from './lib/config'

$(function () {
  const config = defaultViewerConfig()
  window.debug(`Default solid color is: ${config.color}`)

  return new ThreeDViewer('#solid-viewer', function (_, viewer) {
    // Load the file advertised in the DOM, and bind handlers
    // for a ready status differently depending on if we
    // load a diff or a single file.
    try {
      const diff = viewer.$container.data('file1')
      if (isDefined(diff)) {
        viewer.load(viewer.$container.data('file1'), {...config, name: 'file1', center: false})
        viewer.load(viewer.$container.data('file2'), {...config, name: 'file2', center: false})
      } else {
        viewer.load(viewer.$container.data('file'), {
          ...config,
          autoscale: true,
          scaleTo: 100
        })
      }
    } catch (e) {
      viewer.status.set('error')
      throw e
    }
  })
})
